export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fee979dd9caa437ae0413792b6e71318f41812a2b&name=fetchTypeahead!'